// D-268 §1 (EQS-05) — "פיתוחים פעילים" counts every development that is not
// completed and not cancelled (planning / active / on hold).
export const UNFINISHED_DEVELOPMENT_STATUSES = ['planning', 'active', 'on_hold'];

export function countActiveDevelopments(
  engagements: ReadonlyArray<{ type: string; child_status?: string | null }>,
): number {
  return engagements.filter(
    (e) => e.type === 'development' && !!e.child_status && UNFINISHED_DEVELOPMENT_STATUSES.includes(e.child_status),
  ).length;
}
